export default {"src":"/_next/static/media/logo-black.38170f5e.svg","height":254,"width":1646};